import React from 'react';
import {compose} from 'recompose';
import Stage from './Stage';

export const Stages = ({
  authenticated,
  courseId,
  courseSlug,
  currentStage,
  currentStep,
  isDegree,
  refetchCourse,
  stages,
  stagesProgress,
  stepsProgress,
  trackSlug,
  subscription,
}) => {
  if (!stages) return null;
  return stages.map((stage, index) => (
    <Stage
      key={stage.id}
      {...stage}
      authenticated={authenticated}
      index={index}
      courseId={courseId}
      cyStage="first-lesson"
      className={
        (currentStage &&
          currentStage.id === stage.id &&
          'b--black-0125 bg-low-gray tr') ||
        'tr'
      }
      currentStepId={currentStep && currentStep.id}
      isDegree={isDegree}
      refetchCourse={refetchCourse}
      stepsProgress={stepsProgress}
      courseSlug={courseSlug}
      trackSlug={trackSlug}
      stageProgress={stagesProgress[stage.id] || 'not_started'}
      subscription={subscription}
    />
  ));
};

export default compose(Stages);
